import { BlocksApi, ResourceHandlerApi, ViewReaderApi, ZonesApi } from './generated/apis';
import { Configuration } from './generated/runtime';
var configuration = new Configuration({
  basePath: "".concat(window.origin, "/io/solutionviewengine/v1")
});
export var viewsApi = new ViewReaderApi(configuration);
export var zonesApi = new ZonesApi(configuration);
export var blocksApi = new BlocksApi(configuration);
export var customResourceHandlerApi = new ResourceHandlerApi(configuration);
export var Api = {
  Views: viewsApi,
  Zones: zonesApi,
  Blocks: blocksApi
};
export function configureApi(configure) {
  configure(configuration);
}